/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.debounce = debounce;
exports.inView = inView;
exports.getMobileOS = getMobileOS;
function debounce(callback, wait) {
    var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this;

    var timeout = null,
        callbackArgs = null;

    var later = function later() {
        timeout = null;
        if (!immediate) {
            callback.apply(context, callbackArgs);
        }
    };

    return function () {
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        callbackArgs = arguments;
        timeout = setTimeout(later, wait);
        if (callNow) {
            callback.apply(context, callbackArgs);
        }
    };
}

function inView(node) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    var nodeRect = node.getBoundingClientRect(),
        inView = false,
        consoleDebug = false,
        debug = [],
        maxHeight = window.innerHeight + offset;
    if (nodeRect.top > offset && nodeRect.top < maxHeight) {
        inView = true;
        debug.push("top");
    }
    if (nodeRect.bottom > offset && nodeRect.bottom < maxHeight) {
        inView = true;
        debug.push("bottom");
    }
    if (nodeRect.bottom > maxHeight && nodeRect.top < offset) {
        inView = true;
        debug.push("large");
    }
    debug.push("[top: " + nodeRect.top + ", bottom: " + nodeRect.bottom + ", maxHeight: " + maxHeight + "]");
    if (consoleDebug) {
        console.log(debug);
    }
    return inView;
}

function getMobileOS() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Utils = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $ = jQuery;

var Carousel = function () {
    function Carousel() {
        _classCallCheck(this, Carousel);

        this.initCarousel();
    }

    _createClass(Carousel, [{
        key: 'initCarousel',
        value: function initCarousel() {
            var _this = this;

            $('.carousel').each(function (i, node) {
                var DURATION = parseInt($(node).attr('data-autoplay'), 10);
                node._autoplayDuration = DURATION;
                node._autoplay = null;
                node._touchStartX = 0;
                node._touchEndX = 0;
                node._touchStartY = 0;
                node._touchEndY = 0;
                $(node).on('touchstart', '.carousel__item', function (event) {
                    return _this._onTouchStart(event, node);
                });
                $(node).on('touchend', '.carousel__item', function (event) {
                    return _this._onTouchEnd(event, node);
                });
                if (isNaN(DURATION)) {
                    return;
                }
                _this._autoplaySlides(node, DURATION);
                $(node).on('click mouseleave', '.carousel__bullet', function (event) {
                    return _this._restartAnimation(node);
                });
                $(node).on('mouseleave', '.carousel__item', function (event) {
                    return _this._restartAnimation(node);
                });
                $(node).on('mouseenter', '.carousel__item', function (event) {
                    return clearTimeout(node._autoplay);
                });
            });
        }
    }, {
        key: '_autoplaySlides',
        value: function _autoplaySlides(carousel, DURATION) {
            var _this2 = this;

            carousel._autoplay = setTimeout(function () {
                var $slides = $(carousel).find('.carousel__trigger'),
                    $current = $slides.filter(':checked'),
                    index = $slides.index($current),
                    next = index + 1 > $slides.length - 1 ? 0 : index + 1;
                $slides.prop('checked', false).eq(next).prop('checked', true);
                _this2._autoplaySlides(carousel);
            }, carousel._autoplayDuration);
        }
    }, {
        key: '_restartAnimation',
        value: function _restartAnimation(carousel) {
            clearTimeout(carousel._autoplay);
            this._autoplaySlides(carousel);
        }
    }, {
        key: '_onTouchStart',
        value: function _onTouchStart(event, carousel) {
            carousel._touchStartX = event.originalEvent.changedTouches[0].screenX;
            carousel._touchStartY = event.originalEvent.changedTouches[0].screenY;
        }
    }, {
        key: '_onTouchEnd',
        value: function _onTouchEnd(event, carousel) {
            carousel._touchEndX = event.originalEvent.changedTouches[0].screenX;
            carousel._touchEndY = event.originalEvent.changedTouches[0].screenY;
            this._handleGesture(carousel);
        }
    }, {
        key: '_handleGesture',
        value: function _handleGesture(carousel) {
            var DISTANCE_X = carousel._touchStartX - carousel._touchEndX;
            var DISTANCE_Y = carousel._touchStartY - carousel._touchEndY;
            var swipe = 0;

            if (DISTANCE_Y > 100) {
                return;
            }
            if (DISTANCE_X > 20) {
                swipe = 1;
            }
            if (DISTANCE_X < -20) {
                swipe = -1;
            }
            if (swipe === 0) {
                return;
            }
            var $items = $(carousel).find('.carousel__trigger'),
                current = $items.index($items.filter(':checked')),
                max = $items.length - 1,
                next = current + swipe;
            if (next < 0) {
                next = max;
            }
            if (next > max) {
                next = 0;
            }
            $items.prop('checked', false).eq(next).prop('checked', true);
            if (carousel._autoplayDuration > 0) {
                this._restartAnimation(carousel);
            }
        }
    }]);

    return Carousel;
}();

exports.default = Carousel;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CookieBar = function CookieBar() {
    var nodeSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.notification--cookie';

    _classCallCheck(this, CookieBar);

    jQuery('body').on('click', nodeSelector + '  .notification__toggle', function (event) {
        var that = event.currentTarget;
        var thatParent = that.parentNode;
        var date = new Date();
        date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
        document.cookie = 'DDT_COOKIE=1; expires=' + date.toUTCString() + '; path=/';
        thatParent.classList.add('notification--fade-out');
        setTimeout(function () {
            thatParent.remove();
        }, 250);
    });
};

exports.default = CookieBar;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $ = jQuery;

var FormHandler = function () {
    function FormHandler() {
        var _this = this;

        _classCallCheck(this, FormHandler);

        $('.form').attr('novalidate', 'novalidate');
        $('body').on('submit', '.form', function (e) {
            e.preventDefault();
            var form = e.currentTarget,
                errors = _this._validate(form);
            if (errors.length > 0) {
                _this.onError(form, errors);
                return false;
            }
            var data = new FormData(form);
            $.ajax({
                url: window.location.href,
                data: data,
                processData: false,
                contentType: false,
                type: 'POST',
                success: function success(data) {
                    console.log(data);
                    _this.onSuccess(form);
                },
                fail: function fail() {
                    return _this.onError(form);
                }
            });
            return false;
        }).on('click', '.form--success', function (e) {
            $(e.currentTarget).removeClass('form--success');
        });
    }

    _createClass(FormHandler, [{
        key: '_validate',
        value: function _validate(context) {
            var _this2 = this;

            var errors = [];
            $(context).removeClass('form--has-errors form--success').find('.form__field--error').removeClass('form__field--error');
            $(context).find('.form__field').each(function (i, field) {
                var $field = $(field),
                    node = field.firstElementChild;
                if (false === _this2._isNotEmpty($field, node)) {
                    $field.addClass('form__field--error');
                    errors.push($field.attr('data-error'));
                }
            });
            return errors;
        }
    }, {
        key: '_isNotEmpty',
        value: function _isNotEmpty($field, node) {
            if ($field.hasClass('form__field--email')) {
                return this._isEmail(node);
            }
            if (false == $(node).prop('required')) {
                return true;
            }
            if ($field.hasClass('form__field--checkbox')) {
                return $(node).is(':checked');
            }
            if ($field.hasClass('form__field--radio')) {
                return $(node).closest('.form').find('[name="' + $(node).attr('name') + '"]:checked').length > 0;
            }
            return $(node).val() !== '';
        }
    }, {
        key: '_isEmail',
        value: function _isEmail(node) {
            var value = $(node).val();
            if (value === '') {
                return false;
            }
            var email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return email.test(value);
        }
    }, {
        key: 'onError',
        value: function onError(context) {
            var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            $(context).addClass('form--has-errors');
            var $errorNode = $(context).find('.form__errors');
            if ($errorNode.length == 0) {
                $errorNode = $('<div class="form__errors" />');
                $errorNode.insertBefore($(context).find('.form__action--submit'));
            }
            $errorNode.empty();
            if (errors.length == 0) {
                $errorNode.append('<p>' + $(context).attr('data-error') + '</p>');
            } else {
                $.each(errors, function (i, error) {
                    $errorNode.append('<p>' + error + '</p>');
                });
            }
        }
    }, {
        key: 'onSuccess',
        value: function onSuccess(context) {
            var $successNode = $(context).find('.form__message');
            if ($successNode.length == 0) {
                $successNode = $('<div class="form__message" />');
                $successNode.appendTo($(context));
            }
            setTimeout(function () {
                $successNode.empty().append('<p>' + $(context).attr('data-success') + '</p>');
                $(context).addClass('form--success');
            }, 0);
            setTimeout(function () {
                $(context).removeClass('form--success');
            }, 4000);
        }
    }]);

    return FormHandler;
}();

exports.default = FormHandler;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Utils = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $ = jQuery;

var Navigation = function () {
    function Navigation() {
        var _this = this;

        _classCallCheck(this, Navigation);

        this.$content = $('#content');
        this._isFixed = false;
        this.availableHeight = 0;
        this.hoverTimeout = null;
        this.timeoutDelay = 1000;
        this.offset = 40;
        this.elementsOffset = 122;

        $(window).on('scroll', (0, _Utils.debounce)(function () {
            return _this._onScroll();
        }, 10));

        $('body').on('click', '.menu__toggle', function (e) {
            return _this._onCheckedClick(e);
        }).on('mouseenter', '.menu__item--0', function (e) {
            return _this._onHover(e);
        }).on('mousemove', '.menu__item--0', function (e) {
            return _this._clearTimeout(e);
        }).on('mouseleave', '.menu__item--0', function (e) {
            return _this._setTimeout(e);
        });
    }

    _createClass(Navigation, [{
        key: '_onScroll',
        value: function _onScroll() {
            var $win = $(window),
                $nav = $('.menu'),
                $header = $('.header'),
                $carousel = $('.carousel');

            if ($win.scrollTop() >= $header.height() + $carousel.height() + $nav.height() + 30) {
                $nav.addClass('menu--fixed');
            } else {
                $nav.removeClass('menu--fixed');
            }
        }
    }, {
        key: '_onCheckedClick',
        value: function _onCheckedClick(e) {
            var $radio = $('#' + $(e.currentTarget).prop('for'));
            if ($radio.is(':checked')) {
                $radio.removeAttr('checked');
                return false;
            }
        }
    }, {
        key: '_onHover',
        value: function _onHover(e) {
            var $toggle = $(e.currentTarget).find('.menu__toggle');
            if ($toggle.length < 1 || (0, _Utils.getMobileOS)() !== 'unknown') {
                return;
            }
            var $radio = $('#' + $toggle.prop('for'));
            $radio.prop('checked', true);
            this._setTimeout();
        }
    }, {
        key: '_clearTimeout',
        value: function _clearTimeout(e) {
            if (this.hoverTimeout) {
                clearTimeout(this.hoverTimeout);
            }
        }
    }, {
        key: '_setTimeout',
        value: function _setTimeout(e) {
            var _this2 = this;

            this._clearTimeout();
            this.hoverTimeout = setTimeout(function () {
                return _this2._onHoverTimeout();
            }, this.timeoutDelay);
        }
    }, {
        key: '_onHoverTimeout',
        value: function _onHoverTimeout() {
            var $radio = $('.menu__toggler:checked');
            $radio.removeAttr('checked');
        }
    }]);

    return Navigation;
}();

exports.default = Navigation;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! npm.im/object-fit-images 3.2.3 */


var OFI = 'bfred-it:object-fit-images';
var propRegex = /(object-fit|object-position)\s*:\s*([-\w\s%]+)/g;
var testImg = typeof Image === 'undefined' ? {style: {'object-position': 1}} : new Image();
var supportsObjectFit = 'object-fit' in testImg.style;
var supportsObjectPosition = 'object-position' in testImg.style;
var supportsOFI = 'background-size' in testImg.style;
var supportsCurrentSrc = typeof testImg.currentSrc === 'string';
var nativeGetAttribute = testImg.getAttribute;
var nativeSetAttribute = testImg.setAttribute;
var autoModeEnabled = false;

function createPlaceholder(w, h) {
	return ("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E");
}

function polyfillCurrentSrc(el) {
	if (el.srcset && !supportsCurrentSrc && window.picturefill) {
		var pf = window.picturefill._;
		// parse srcset with picturefill where currentSrc isn't available
		if (!el[pf.ns] || !el[pf.ns].evaled) {
			// force synchronous srcset parsing
			pf.fillImg(el, {reselect: true});
		}

		if (!el[pf.ns].curSrc) {
			// force picturefill to parse srcset
			el[pf.ns].supported = false;
			pf.fillImg(el, {reselect: true});
		}

		// retrieve parsed currentSrc, if any
		el.currentSrc = el[pf.ns].curSrc || el.src;
	}
}

function getStyle(el) {
	var style = getComputedStyle(el).fontFamily;
	var parsed;
	var props = {};
	while ((parsed = propRegex.exec(style)) !== null) {
		props[parsed[1]] = parsed[2];
	}
	return props;
}

function setPlaceholder(img, width, height) {
	// Default: fill width, no height
	var placeholder = createPlaceholder(width || 1, height || 0);

	// Only set placeholder if it's different
	if (nativeGetAttribute.call(img, 'src') !== placeholder) {
		nativeSetAttribute.call(img, 'src', placeholder);
	}
}

function onImageReady(img, callback) {
	// naturalWidth is only available when the image headers are loaded,
	// this loop will poll it every 100ms.
	if (img.naturalWidth) {
		callback(img);
	} else {
		setTimeout(onImageReady, 100, img, callback);
	}
}

function fixOne(el) {
	var style = getStyle(el);
	var ofi = el[OFI];
	style['object-fit'] = style['object-fit'] || 'fill'; // default value

	// Avoid running where unnecessary, unless OFI had already done its deed
	if (!ofi.img) {
		// fill is the default behavior so no action is necessary
		if (style['object-fit'] === 'fill') {
			return;
		}

		// Where object-fit is supported and object-position isn't (Safari < 10)
		if (
			!ofi.skipTest && // unless user wants to apply regardless of browser support
			supportsObjectFit && // if browser already supports object-fit
			!style['object-position'] // unless object-position is used
		) {
			return;
		}
	}

	// keep a clone in memory while resetting the original to a blank
	if (!ofi.img) {
		ofi.img = new Image(el.width, el.height);
		ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
		ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;

		// preserve for any future cloneNode calls
		// https://github.com/bfred-it/object-fit-images/issues/53
		nativeSetAttribute.call(el, "data-ofi-src", el.src);
		if (el.srcset) {
			nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
		}

		setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);

		// remove srcset because it overrides src
		if (el.srcset) {
			el.srcset = '';
		}
		try {
			keepSrcUsable(el);
		} catch (err) {
			if (window.console) {
				console.warn('https://bit.ly/ofi-old-browser');
			}
		}
	}

	polyfillCurrentSrc(ofi.img);

	el.style.backgroundImage = "url(\"" + ((ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"')) + "\")";
	el.style.backgroundPosition = style['object-position'] || 'center';
	el.style.backgroundRepeat = 'no-repeat';
	el.style.backgroundOrigin = 'content-box';

	if (/scale-down/.test(style['object-fit'])) {
		onImageReady(ofi.img, function () {
			if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
				el.style.backgroundSize = 'contain';
			} else {
				el.style.backgroundSize = 'auto';
			}
		});
	} else {
		el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%');
	}

	onImageReady(ofi.img, function (img) {
		setPlaceholder(el, img.naturalWidth, img.naturalHeight);
	});
}

function keepSrcUsable(el) {
	var descriptors = {
		get: function get(prop) {
			return el[OFI].img[prop ? prop : 'src'];
		},
		set: function set(value, prop) {
			el[OFI].img[prop ? prop : 'src'] = value;
			nativeSetAttribute.call(el, ("data-ofi-" + prop), value); // preserve for any future cloneNode
			fixOne(el);
			return value;
		}
	};
	Object.defineProperty(el, 'src', descriptors);
	Object.defineProperty(el, 'currentSrc', {
		get: function () { return descriptors.get('currentSrc'); }
	});
	Object.defineProperty(el, 'srcset', {
		get: function () { return descriptors.get('srcset'); },
		set: function (ss) { return descriptors.set(ss, 'srcset'); }
	});
}

function hijackAttributes() {
	function getOfiImageMaybe(el, name) {
		return el[OFI] && el[OFI].img && (name === 'src' || name === 'srcset') ? el[OFI].img : el;
	}
	if (!supportsObjectPosition) {
		HTMLImageElement.prototype.getAttribute = function (name) {
			return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
		};

		HTMLImageElement.prototype.setAttribute = function (name, value) {
			return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
		};
	}
}

function fix(imgs, opts) {
	var startAutoMode = !autoModeEnabled && !imgs;
	opts = opts || {};
	imgs = imgs || 'img';

	if ((supportsObjectPosition && !opts.skipTest) || !supportsOFI) {
		return false;
	}

	// use imgs as a selector or just select all images
	if (imgs === 'img') {
		imgs = document.getElementsByTagName('img');
	} else if (typeof imgs === 'string') {
		imgs = document.querySelectorAll(imgs);
	} else if (!('length' in imgs)) {
		imgs = [imgs];
	}

	// apply fix to all
	for (var i = 0; i < imgs.length; i++) {
		imgs[i][OFI] = imgs[i][OFI] || {
			skipTest: opts.skipTest
		};
		fixOne(imgs[i]);
	}

	if (startAutoMode) {
		document.body.addEventListener('load', function (e) {
			if (e.target.tagName === 'IMG') {
				fix(e.target, {
					skipTest: opts.skipTest
				});
			}
		}, true);
		autoModeEnabled = true;
		imgs = 'img'; // reset to a generic selector for watchMQ
	}

	// if requested, watch media queries for object-fit change
	if (opts.watchMQ) {
		window.addEventListener('resize', fix.bind(null, imgs, {
			skipTest: opts.skipTest
		}));
	}
}

fix.supportsObjectFit = supportsObjectFit;
fix.supportsObjectPosition = supportsObjectPosition;

hijackAttributes();

module.exports = fix;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _objectFitImages = __webpack_require__(5);

var _objectFitImages2 = _interopRequireDefault(_objectFitImages);

var _CookieBar = __webpack_require__(2);

var _CookieBar2 = _interopRequireDefault(_CookieBar);

var _Navigation = __webpack_require__(4);

var _Navigation2 = _interopRequireDefault(_Navigation);

var _FormHandler = __webpack_require__(3);

var _FormHandler2 = _interopRequireDefault(_FormHandler);

var _Carousel = __webpack_require__(1);

var _Carousel2 = _interopRequireDefault(_Carousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// object-fit polyfill

var $ = jQuery;

var $body = $('body');
var $window = $(window);

var clearLoading = function clearLoading() {
    $('.loader').remove();
    $body.removeClass('is-loading').addClass('has-loaded');
    clearTimeout(isLoaded);
};

var checkLoadingState = function checkLoadingState() {
    if (document.readyState === 'complete') {
        clearLoading();
    } else {
        setTimeout(function () {
            return checkLoadingState();
        }, 100);
    }
};

var isLoaded = setTimeout(clearLoading, 600);

$window.on('load', clearLoading);

$(document).ready(function () {
    // Load CookieBar
    new _CookieBar2.default();

    // Load Navigation
    new _Navigation2.default();

    // Load FormHandler
    new _FormHandler2.default();

    // Load Carousel
    new _Carousel2.default();

    // Init scroll handlers
    $(window).scroll();

    // Manually clear loading, if not cleared yet
    checkLoadingState();

    // Load object-fit polyfill
    (0, _objectFitImages2.default)($('.media--fullscreen img'));
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app/themes/template/res/js/dist/main.js